function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.2169 8.25261L13.7813 10.9597C14.08 11.2084 14.0715 11.6362 13.7632 11.8751C13.5015 12.078 13.1128 12.0721 12.8588 11.8614L10.5 9.33367L8.14117 11.8614C7.88719 12.0721 7.49846 12.078 7.23678 11.8751C6.92847 11.6362 6.92001 11.2084 7.21867 10.9597L9.78313 8.25261C9.78313 8.25261 10.0763 8.02344 10.5 8.02344C10.9237 8.02344 11.2169 8.25261 11.2169 8.25261Z",
  fill: "#626262"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.2169 8.25261L13.7813 10.9597C14.08 11.2084 14.0715 11.6362 13.7632 11.8751C13.5015 12.078 13.1128 12.0721 12.8588 11.8614L10.5 9.33367L8.14117 11.8614C7.88719 12.0721 7.49846 12.078 7.23678 11.8751C6.92847 11.6362 6.92001 11.2084 7.21867 10.9597L9.78313 8.25261C9.78313 8.25261 10.0763 8.02344 10.5 8.02344C10.9237 8.02344 11.2169 8.25261 11.2169 8.25261Z",
  fill: "#69707D"
});

const SvgArrowUp = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow_up.5a292363.svg";
export { ForwardRef as ReactComponent };